import axios, { type AxiosError } from 'axios';
import * as Sentry from '@sentry/react';
import { useAuthStore } from '@/store/authStore';
import { usePrivacyStore } from '@/store/privacyStore';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor (add JWT token)
api.interceptors.request.use(
  (config) => {
    const token = useAuthStore.getState().token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // 개인정보 가림 해제 중이면 서버가 원본을 보내도록 해제 토큰을 싣는다
    const revealToken = usePrivacyStore.getState().revealToken;
    if (revealToken) {
      config.headers['X-Pii-Reveal'] = revealToken;
    }
    return config;
  },
  (error) => {
    Sentry.captureException(error);
    return Promise.reject(error);
  }
);

// Response interceptor (error handling)
api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // 로그인 페이지에서는 401 리다이렉트 하지 않음
    if (error.response?.status === 401 && !error.config?.url?.includes('/auth/login')) {
      useAuthStore.getState().clearAuth();
      window.location.href = '/login';
    }

    Sentry.captureException(error);
    return Promise.reject(error);
  }
);

export default api;
